module.exports = __webpack_public_path__ + "img/d_training.41d1a6ff.png";